import { render } from "./WebDevelopment.vue?vue&type=template&id=9d3f3cee"
import script from "./WebDevelopment.vue?vue&type=script&lang=js"
export * from "./WebDevelopment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__